import {GET_FORM_KLARIFIKASI} from 'shared/constants/ActionTypes';

const initialState = {
  form: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FORM_KLARIFIKASI:
      return {
        ...state,
        form: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
